/** UIS credentials worked; this membership is not allowed into AcuityLearn. */
export const PLATFORM_ACCESS_DENIED_TITLE = "No access to this platform";

export const PLATFORM_ACCESS_DENIED_MESSAGE =
  "You do not have access to this platform.";

export function platformAccessDeniedMessage(code?: string | null): string {
  if (code === "NO_ROLE") {
    return `${PLATFORM_ACCESS_DENIED_MESSAGE} No AcuityLearn role is granted for this membership.`;
  }
  if (code === "NO_SCHOOL") {
    return `${PLATFORM_ACCESS_DENIED_MESSAGE} No school is recognized for this membership.`;
  }
  if (code === "NO_MEMBERSHIP") {
    return `${PLATFORM_ACCESS_DENIED_MESSAGE} This account has no UIS membership in window.`;
  }
  return PLATFORM_ACCESS_DENIED_MESSAGE;
}

/** Location state carried when kicking a user home for missing page_access. */
export type AccessDeniedState = {
  page?: string;
  from?: string;
  at?: number;
};

export type AccessDeniedLocationState = {
  accessDenied?: AccessDeniedState;
};

export function accessDeniedNavigateState(
  page?: string,
  from?: string,
): AccessDeniedLocationState {
  return {
    accessDenied: {
      ...(page ? { page } : {}),
      ...(from ? { from } : {}),
      at: Date.now(),
    },
  };
}

/** Location state carried when kicking a user home for a URL that has no route. */
export type UnknownRouteState = {
  from?: string;
  at?: number;
};

export type UnknownRouteLocationState = {
  unknownRoute?: UnknownRouteState;
};

export function unknownRouteNavigateState(from?: string): UnknownRouteLocationState {
  return {
    unknownRoute: {
      ...(from ? { from } : {}),
      at: Date.now(),
    },
  };
}
